import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import TopRoutes from '@top/pages';
import AppProviders from '@shared/components/AppProviders';
document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('root');
    if (container) {
        const root = createRoot(container);
        root.render(React.createElement(AppProviders, null,
            React.createElement(BrowserRouter, null,
                React.createElement(TopRoutes, null))));
    }
});
